<script setup lang="ts">
import { Property } from "~/classes/entity"

const { addSearchFacet } = useInstantMenu()
const { showableProperties } = useViewMode()

const filterableProperties = Object
  .values(showableProperties)
  .filter(details => details.filterable)
  .filter(details => ![Property.FILE_VIRTUAL_TAGS].includes(details.propertyId))

const addFilter = (propertyId: string, toggle: () => void) => {
  // TODO default value, based on the schema type of the property
  addSearchFacet({ propertyId, facetType: { exists: true } })
  toggle()
}
</script>

<template>
  <dropdown
    anchor-x="left"
    anchor-y="bottom"
    flow-x="right"
    flow-y="down"
  >
    <template #default="{ toggle }">
      <nav-instant-shortcut
        label="Filter"
        @click="toggle()"
      />
    </template>
    <template #menu="{ toggle }">
      <dropdown-menu class="inline-select-container">
        <div class="inline-select-dropdown">
          <menu-section>
            <div
              v-for="{ name, propertyId } in filterableProperties"
              :key="propertyId"
              class="inline-select-option-container"
              @click="addFilter(propertyId, toggle)"
            >
              <div class="inline-select-option">
                {{ name }}
              </div>
            </div>
          </menu-section>
        </div>
      </dropdown-menu>
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.inline-select-container
  @apply mt-2
  @apply w-40

.inline-select-dropdown
  @apply flex flex-col
  @apply overflow-auto
  max-height: calc(100vh - 60px)

.inline-select-option-container
  @apply flex flex-grow cursor-pointer items-center
  @apply rounded-[#{$menu-br-item}] m-[#{$menu-m-hover-outer}] p-[#{$menu-p-hover-inner}]
  @apply text-[#{$global-t-default}] t-menu-sm
  @apply flex cursor-pointer items-center
  @apply rounded-[#{$menu-br-item}] hover:bg-[#{$menu-bg-item-hover}]
  .icon
    @apply ml-auto h-4 w-4 text-[#{$global-bg-icon-secondary}]

.inline-select-option
  @apply flex items-center
</style>
